import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { rhm, apiError } from "./api";

const Ctx = createContext(null);

export function RhmAuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        if (!localStorage.getItem("rhm_token")) {
            setUser(null);
            setLoading(false);
            return;
        }
        try {
            const { data } = await rhm.get("/auth/me");
            setUser(data);
        } catch {
            localStorage.removeItem("rhm_token");
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const login = async (email, password) => {
        try {
            const { data } = await rhm.post("/auth/login", { email, password });
            localStorage.setItem("rhm_token", data.token);
            setUser(data.user);
            return { ok: true };
        } catch (e) {
            return { ok: false, error: apiError(e) };
        }
    };

    const logout = async () => {
        try { await rhm.post("/auth/logout"); } catch { /* ignore */ }
        localStorage.removeItem("rhm_token");
        setUser(null);
    };

    const can = (perm) => {
        if (!user) return false;
        if (user.is_super_admin) return true;
        const [module, action] = perm.split(".");
        return (user.permissions?.[module] || []).includes(action);
    };

    return (
        <Ctx.Provider value={{ user, loading, login, logout, can, refresh }}>
            {children}
        </Ctx.Provider>
    );
}

export const useRhmAuth = () => useContext(Ctx);
